import React from 'react';
import { HistoricOperationsStatusView } from '@fingo/lib/features/operations-status';
import CessionStatusOverlay from '../../../../features/factoring/components/overlays/CessionStatusOverlay';
import {
  getHistoricSummaryCards,
  DETAIL_SUMMARY_TABLE_COLUMNS,
} from '../../../../features/factoring/constants/operations-status';
import buildBchSteps from '../../../../features/factoring/helpers/invoiceTrackingSteps';

const HistoricOperationsStatus = () => (
  <HistoricOperationsStatusView
    getCards={getHistoricSummaryCards}
    summaryTableColumns={DETAIL_SUMMARY_TABLE_COLUMNS}
    getTrackingSteps={buildBchSteps}
    useBorderedTitle
    OverlayComponent={CessionStatusOverlay}
  />
);

export default HistoricOperationsStatus;
